import Vue from 'vue'
import _state from './state'
import * as mutations from '@store/_mutations'
import ls from '../utils/localStorage'
export default {
    [mutations.SET_CAPABILITIES](state, capabilities) {
        state.capabilities = capabilities.sort((a, b) => a.localeCompare(b))
        ls.save(state)
    },
    [mutations.SET_COUNCIL](state, council) {
        state.council = council
        ls.save(state)
    },
    [mutations.SET_CURRENT_MEETING](state, meeting) {
        state.currentMeeting = meeting
        ls.save(state)
    },
    [mutations.SET_STATE](state, data) {
        Object.keys(_state).forEach((key) => data.hasOwnProperty(key) && Vue.set(state, key, data[key]))
    },
    [mutations.SET_CURRENT_USER](state, user) {
        state.currentUser = user
        ls.save(state)
    },
    [mutations.SET_CURRENT_CLIENT](state, client) {
        state.currentClient = client
        ls.save(state)
    },
    [mutations.SET_CURRENT_GUARD](state, guard) {
        state.currentGuard = guard
        ls.save(state)
    },
    [mutations.SET_CURRENT_RESOURCE](state, resource) {
        state.currentResource = resource
        ls.save(state)
    },
    [mutations.SET_CURRENT_PERSON](state, person) {
        state.currentPerson = person
        ls.save(state)
    },
    [mutations.SET_CURRENT_SHIFT](state, shift) {
        state.currentShift = shift
        ls.save(state)
    },
    [mutations.SET_CURRENT_UNIT](state, unit) {
        const configurations = {}
        if (!!unit.configurations) {
            unit.configurations.map((item) => (configurations[item.key] = item.value))
        }
        state.currentUnit = {
            ...unit,
            configurations,
        }
        ls.save(state)
    },
    [mutations.SET_CURRENT_VENUE](state, venue) {
        state.currentVenue = venue
        ls.save(state)
    },
    [mutations.SET_CURRENT_WORKPLACE](state, workplace) {
        state.currentWorkplace = workplace
        ls.save(state)
    },
    [mutations.SET_MENU](state, menu) {
        state.menu = menu
        ls.save(state)
    },
    [mutations.SET_MENU_ITEMS](state, items) {
        state.menuItems = items
        ls.save(state)
    },
    [mutations.SET_CURRENT_PROFILE](state, profile) {
        state.currentProfile = profile
        ls.save(state)
    },
    [mutations.ADD_PENDING_REQUESTS](state) {
        state.pendingRequests = state.pendingRequests + 1
    },
    [mutations.SUB_PENDING_REQUESTS](state) {
        state.pendingRequests = Math.max(state.pendingRequests - 1, 0)
    },
    [mutations.SET_PERSON_ROLES](state, roles) {
        state.personRoles = roles
        ls.save(state)
    },
    [mutations.SET_POLLS](state, polls) {
        state.polls = polls
    },
    [mutations.SET_SYSTEM_PARAMS](state, params) {
        state.systemParams = params
    },
    [mutations.SET_USER_POLLS_READY](state, pollIds) {
        state.userPollsReady = pollIds
        ls.save(state)
    },
    [mutations.SET_GUARD_NOTIFICATIONS](state, notificationsIds) {
        state.guardNotifications = notificationsIds
        ls.save(state)
    },
    [mutations.SET_CURRENT_SURVEY](state, survey) {
        state.currentSurvey = survey
        ls.save(state)
    },
    [mutations.SET_CURRENT_EVENT](state, event) {
        state.currentEvent = event
        ls.save(state)
    },
    [mutations.SET_TASK](state, task) {
        state.task = task
    },
    [mutations.SET_IS_RESELLER](state, isReseller) {
        state.isReseller = isReseller
        ls.save(state)
    },
    [mutations.CLEAR_STATE](state) {
        Object.keys(state).forEach((key) => (state[key] = null))
        ls.clear()
    },
    [mutations.SET_CLIENT_CONFIG](state, config) {
        state.clientConfig = config
        ls.save(state)
    },
    // chat
    [mutations.SET_AGENT](state, agent) {
        state.agent = agent
    },
    [mutations.SET_SELECTED_CONVERSATION](state, conversation) {
        state.selectedConversation = conversation
    },
    [mutations.SET_CONVERSATIONS](state, conversations) {
        /**
         * Los estados de los mensajes son:
         * - waiting: el último mensaje fue enviado por el agente
         * - tracking: el último mensaje fue enviado por el usuario y no se ha pasado el tiempo maximo para contestar
         * - pending: el último mensaje fue enviado por el usuario y se ha pasado el tiempo maximo para contestar
         */
        state.conversations = conversations.map((conversation) => {
            let status = conversation.status
            if (conversation.last_message_role === 'user') {
                status = conversation.status === 'pending' ? 'pending' : 'tracking'
            } else if (conversation.last_message_role === 'agent') {
                status = 'waiting'
            }

            return {
                ...conversation,
                status,
            }
        })
    },
    [mutations.SET_HISTORY_CONVERSATIONS](state, conversations) {
        /**
         * Los estados de los mensajes son:
         * - waiting: el último mensaje fue enviado por el agente
         * - tracking: el último mensaje fue enviado por el usuario y no se ha pasado el tiempo maximo para contestar
         * - pending: el último mensaje fue enviado por el usuario y se ha pasado el tiempo maximo para contestar
         */
        state.historyConversations = conversations.map((conversation) => {
            let status = conversation.status
            if (conversation.last_message_role === 'user') {
                status = conversation.status === 'pending' ? 'pending' : 'tracking'
            } else if (conversation.last_message_role === 'agent') {
                status = 'waiting'
            }

            return {
                ...conversation,
                status,
            }
        })
    },
    [mutations.SET_LOGING_IN_PROGRESS](state, value) {
        state.loginInProgress = value
    },
    [mutations.SET_MESSAGES](state, messages) {
        state.messages = messages
    },
    [mutations.SET_HISTORY_MESSAGES](state, messages) {
        state.historyMessages = messages
    },
    [mutations.ADD_MESSAGE](state, message) {
        state.messages.unshift(message)
    },
    [mutations.ADD_HISTORY_MESSAGE](state, message) {
        state.historyMessages.unshift(message)
    },
    [mutations.SET_SEARCH_TERM](state, term) {
        state.searchTerm = term
    },
    [mutations.SET_AGENT_CONNECTION](state, connection) {
        state.agentConnection = connection
    },
}
